import React from 'react';
import PropTypes from 'prop-types';

import './Banner.scss';

const Banner = (props) => {
    const classes = `banner banner--${props.style}`;

    return <div className={classes}>{props.children}</div>;
};

Banner.propTypes = {
    style: PropTypes.string,
    children: PropTypes.node,
};

export default Banner;
